<template>
  <StatusChip tone="neutral" class="agentPill">Agent</StatusChip>
</template>

<script setup lang="ts">
// Small text marker denoting a setting or record driven by the automated voice
// agent (the calls/voicemails it places on the rep's behalf) — as opposed to
// the rep's own live dialing. Reused on agent-owned settings cards and on
// agent-only rows in call history.
import StatusChip from './StatusChip.vue'
</script>
